export default __webpack_public_path__ + "static/media/login-2.6300fb69.png";